import React from 'react'
import isEmpty from 'lodash/isEmpty'

import * as styles from './tablecontent.module.scss'

import TextElement from '@/components/text-element/text-element'

const TableContent = ({ title, contents, twocolumns = true }) => {
  if (isEmpty(contents)) return <></>
  return (
    <div className={`${styles.tablecontent} mb-5 mt-3`}>
      <TextElement type="h2" text={title} uppercase border />
      <div className="row pt-md-4">
        {contents.map((item) => (
          <div className={twocolumns ? 'col-lg-6 mb-lg-4' : ''} key={item.id}>
            <h3>{item.name}</h3>
            <p>{item.description}</p>
          </div>
        ))}
      </div>
    </div>
  )
}

export default TableContent
